import { render } from "./ModalSenders.vue?vue&type=template&id=03302ba8"
import script from "./ModalSenders.vue?vue&type=script&lang=js"
export * from "./ModalSenders.vue?vue&type=script&lang=js"

import "./ModalSenders.vue?vue&type=style&index=0&id=03302ba8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__